import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function CroCaseStudies() {
    return (
        <section id="case-studies" className="cro-case-studies">
            <Container>
                <div className="section-header cro-reveal">
                    <span className="cro-section-label">Proven Results</span>
                    <h2 className="cro-section-title">
                        Case studies that <span className="highlight">speak in numbers</span>
                    </h2>
                </div>

                <Row>
                    <Col lg={6} className="mb-4">
                        <div className="cro-case-card cro-reveal cro-delay-1">
                            <div className="case-phase">
                                <div className="phase-item">
                                    <span className="phase-label">Problem</span>
                                    <span className="phase-text">High bounce rate on mobile landing page — 72% of paid traffic was leaving within 3 seconds.</span>
                                </div>
                                <div className="phase-item">
                                    <span className="phase-label">Analysis</span>
                                    <span className="phase-text">Heatmap data showed hero section lacked clear CTA, trust indicators were below fold, and LCP was 4.2 seconds.</span>
                                </div>
                                <div className="phase-item">
                                    <span className="phase-label">Solution</span>
                                    <span className="phase-text">Redesigned mobile hierarchy with sticky CTA, compressed images to hit 1.8s LCP, added social proof above fold.</span>
                                </div>
                            </div>
                            <div className="cro-case-metrics">
                                <div className="cro-case-metric">
                                    <span className="metric-value">+22%</span>
                                    <span className="metric-label">CTA Clicks</span>
                                </div>
                                <div className="cro-case-metric">
                                    <span className="metric-value">−38%</span>
                                    <span className="metric-label">Bounce Rate</span>
                                </div>
                                <div className="cro-case-metric">
                                    <span className="metric-value">+14%</span>
                                    <span className="metric-label">Revenue</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                        <div className="cro-case-card cro-reveal cro-delay-2">
                            <div className="case-phase">
                                <div className="phase-item">
                                    <span className="phase-label">Problem</span>
                                    <span className="phase-text">Checkout abandonment at 78% — customers were dropping at the payment information step.</span>
                                </div>
                                <div className="phase-item">
                                    <span className="phase-label">Analysis</span>
                                    <span className="phase-text">Session recordings revealed confusion around shipping costs appearing late, plus 6 unnecessary form fields.</span>
                                </div>
                                <div className="phase-item">
                                    <span className="phase-label">Solution</span>
                                    <span className="phase-text">Showed estimated shipping on product page, reduced form fields by 50%, added progress bar and guest checkout.</span>
                                </div>
                            </div>
                            <div className="cro-case-metrics">
                                <div className="cro-case-metric">
                                    <span className="metric-value">+18%</span>
                                    <span className="metric-label">Checkouts</span>
                                </div>
                                <div className="cro-case-metric">
                                    <span className="metric-value">+12%</span>
                                    <span className="metric-label">Rev / Visitor</span>
                                </div>
                                <div className="cro-case-metric">
                                    <span className="metric-value">−25%</span>
                                    <span className="metric-label">Cart Abandon</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

